import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'referral_sources',
  inputShow: gql`
    query referralSources($input: ReferralSourceQueryInput) {
      referralSources(input: $input) {
        id
        label
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Referral Sources',
  },
};
